'use memo'

import { CrmAgencyConnectionProviderResponseProvider } from '@urbanx/agx.crm.client'
import agentboxLogo from 'assets/images/crm-agentbox.png'
import boxAndDiceLogo from 'assets/images/crm-box-and-dice.png'
import rexLogo from 'assets/images/crm-rex.png'
import vaultLogo from 'assets/images/crm-vault.png'

const crmProviderLogos = {
  [CrmAgencyConnectionProviderResponseProvider.Agentbox]: agentboxLogo,
  [CrmAgencyConnectionProviderResponseProvider.BoxAndDice]: boxAndDiceLogo,
  [CrmAgencyConnectionProviderResponseProvider.Rex]: rexLogo,
  [CrmAgencyConnectionProviderResponseProvider.Vault]: vaultLogo,
} satisfies Partial<Record<CrmAgencyConnectionProviderResponseProvider, string>>

const CrmIcon = ({
  crmProvider,
}: {
  crmProvider: CrmAgencyConnectionProviderResponseProvider
}) => {
  const logo = crmProviderLogos[crmProvider]

  if (!logo) {
    return null
  }

  return (
    <img
      src={logo}
      alt=""
      aria-hidden="true"
      width={40}
      height={40}
      style={{
        backgroundColor: '#F1F5F6',
        borderRadius: 8,
        display: 'block',
        objectFit: 'cover',
      }}
    />
  )
}

export default CrmIcon
